export function isNotNil<T>(value: T | null | undefined): value is T {
  return value !== null && value !== undefined
}

export function isKeyInObject<T extends Record<string, unknown>>(
  key: string,
  obj: T
): key is keyof T & string {
  return key in obj
}

export function arrayIncludes<T extends readonly unknown[]>(
  array: T,
  value: unknown
): value is T[number] {
  return (array as readonly unknown[]).includes(value)
}

export function setHas<T>(set: Set<T>, value: unknown): value is T {
  return (set as Set<unknown>).has(value)
}
